var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-16"},[(_vm.smAndDown)?_c('CategoriesSection'):_vm._e(),_c('SlideShowSection'),(!_vm.smAndDown)?_c('CategoriesSection'):_vm._e(),_c('ProductsByCategoriesSection'),_c('ProductModalWidget')],1)}
var staticRenderFns = []

export { render, staticRenderFns }